import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

@Component({
  selector: 'app-chips-list',
  templateUrl: './chips-list.component.html',
  styleUrls: []
})
export class ChipsListComponent implements OnInit {

  @Input() config: ChipsListConfig;
  @Input() chipsValues: ChipValue[];

  @Output() chipRemoval: EventEmitter<ChipRemovalEvent> = new EventEmitter<ChipRemovalEvent>();

  get chipsConfig(): ChipConfig[] {
    return this.config.chips;
  }

  get definedChipsValues(): ChipValue[] {
    return this.chipsValues.filter(chipValue => isNotNullOrUndefined(chipValue.value));
  }

  constructor() { }

  ngOnInit() {
  }

  remove(chipKey: string): void {
    const removedChipValue = this.chipsValues.find(chipValue => chipValue.key === chipKey).value;
    this.chipsValues.find(chipValue => chipValue.key === chipKey).value = null;
    this.chipRemoval.emit({
      fieldKey: chipKey,
      value: removedChipValue
    });
  }

  getChipConfig(chipKey: string): ChipConfig {
    return this.chipsConfig.find(chipConfig => chipConfig.key === chipKey);
  }

  shouldInsertBreak(chipKey: string): boolean {
    return this.config.breakingEnabled && this.config.breakAfterChips.includes(chipKey);
  }

}

export interface ChipsListConfig {
  chips: ChipConfig[];
  selectable?: boolean;
  breakingEnabled?: boolean;
  breakAfterChips?: string[]; // array of chips keys after which line should be break
}

export interface ChipConfig {
  key: string;
  // label: string;
  icon?: string;
  allowRemoval?: boolean;
  visible?: boolean;
}

export interface ChipValue {
  key: string;
  value: string | number;
  description?: string;
  visible?: boolean;
}

export interface ChipRemovalEvent {
  fieldKey: string;
  value?: any;
}
